import { notification } from 'antd';
import { localVariables } from '../../utils/constants';
import apiClient from '../client';
const ENDPOINT = 'auth';

export const authApi = {
    login: (payload, t) => {
        const translate = (key, fallback) => (t && typeof t === 'function' ? t(key) : fallback);

        return apiClient.post(`/${ENDPOINT}/login`, payload).catch((err) => {
            const errText = err?.response?.data?.message || '';

            if (errText.includes('not found')) {
                notification.info({
                    message: translate(
                        'AuthApi_NoAccountFound',
                        'No account found with this email address'
                    )
                });
            } else if (errText.includes('Invalid password')) {
                notification.info({
                    message: translate('AuthApi_WrongPassword', 'Wrong password')
                });
            } else if (errText.includes('inactive')) {
                notification.info({
                    message: translate('AuthApi_AccountNotVerified', 'Account is not verified')
                });
            } else {
                notification.info({
                    message: translate(
                        'AuthApi_ContactAdmin',
                        'Something has occurred, please contact Admin'
                    )
                });
            }
            console.error(err);
        });
    },
    register: (payload) => {
        return apiClient.post(`/${ENDPOINT}/register`, payload);
    },
    forrgotPassword: (payload) => {
        return apiClient.post(`/${ENDPOINT}/forgot-password`, payload);
    },
    activeAccount: (payload) => {
        return apiClient.get(`/${ENDPOINT}/active_user?token=${payload}`);
    },
    changePassword: (payload) => {
        return apiClient.patch(`/${ENDPOINT}/change-password`, payload);
    },
    saveAuthData: ({ accessToken, accessTokenExp, roles }) => {
        localStorage.setItem(localVariables.ACCESSTOKEN, accessToken);
        localStorage.setItem(localVariables.accessTokenExp, accessTokenExp);
        localStorage.setItem(localVariables.ROLES, JSON.stringify(roles));
    },
    clearAuthData: () => {
        apiClient.post(`/${ENDPOINT}/logout`).then(() => {
            localStorage.removeItem(localVariables.ACCESSTOKEN);
            localStorage.removeItem(localVariables.accessTokenExp);
            localStorage.removeItem(localVariables.ROLES);
        });
    }
};
